import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { useSelector } from "react-redux";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

export default function DropdownCmp2({
  options,
  label = "نامشخص",
  value,
  name,
  id,
  onChange,
  error,
  onBlur,
  onSelect,
  onClick,
  style,
}: {
  options: any;
  label: string;
  value?: any;
  name: any;
  id: any;
  onChange: any;
  error?: any;
  onBlur?: any;
  onSelect?: any;
  onClick?: any;
  style?: any;
}) {
  const [values, setValues] = React.useState({
    age: "",
    name: "hai",
  });

  // React.useEffect(() => {
  //     setLabelWidth(inputLabel.current.offsetWidth);
  // }, []);

  function handleChange(event: any) {
    setValues((oldValues) => ({
      ...oldValues,
      [event.target.name]: event.target.value,
    }));
  }
  const jsonFile = useSelector((state: any) => state.style);
  const css = `
.Mui-selected{
    background: ${jsonFile?.mainColor} !important;
}
`;

  return (
    <CacheProvider value={cacheRtl}>
      <style>{css}</style>
      <ThemeProvider theme={theme}>
        <div dir="rtl" style={style}>
          <FormControl
            fullWidth
            sx={{
              "& .MuiMenu-list": {
                backgroundColor: "#1B3045",
                // marginTop: "0.8vh",
              },
            }}
          >
            <InputLabel
              className="colorTitle "
              htmlFor="outlined-age-simple"
              color={jsonFile?.muiColor}
              // style={jsonFile?.muiColor === "success" ? {} : { top: "-3px" }}
            >
              {label}
            </InputLabel>
            <Select
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: "#1B3045",
                    "& .MuiMenu-list": {
                      backgroundColor: "#1B3045",
                      paddingRight: " 2vh !important",
                      paddingLeft: " 2vh !important",
                    },
                    "&.MuiPopover-paper": {
                      backgroundColor: "#1B3045",
                      borderRadius: "5px !important",
                      maxHeight: "400px",
                    },
                  },
                },
              }}
              onClick={onClick}
              onBlur={onBlur}
              error={error}
              value={value}
              color={jsonFile?.muiColor}
              onSelect={onSelect}
              onChange={onChange}
              input={<OutlinedInput name={name} id={name} label={label} />}
              style={{
                paddingTop: "10px",
                width: "100%",
                boxShadow:
                  "0 0px 1px 0 rgba(0, 0, 0, 0), 0 1px 1px 0 rgba(0, 0, 0, 0.2)",
                borderRadius: "3px",
              }}
            >
              {/* <MenuItem value="">
                    <span>هیچکدام</span>
                </MenuItem> */}
              {options != null &&
                options.length > 0 &&
                options.map((item: any, index: any) => (
                  <MenuItem
                    style={{
                      margin: "5px",
                      fontSize: "2px !important",
                      borderBottom:
                        index === options.length - 1
                          ? "none"
                          : "1px solid rgba(255, 255, 255, 0.25)",
                      backgroundColor: "#1B3045",
                      color: "#fff",
                    }}
                    key={item.id}
                    value={item.enumData ? item.enumData : item.text}
                  >
                    {item.enumData ? item.title : item.text}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>
      </ThemeProvider>
    </CacheProvider>
  );
}
